import { makeStyles } from '../../../styles';
export const useStyles = makeStyles((theme) => ({
    root: Object.assign(Object.assign({}, theme.typography.body1), { color: theme.colors.text[900] }),
}));
//# sourceMappingURL=Breadcrumbs.styles.js.map